import React from 'react'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { useLanguage } from '../contexts/LanguageContext'

const Breadcrumb: React.FC = () => {
  const location = useLocation()
  const { language } = useLanguage()
  
  // Generate breadcrumb items based on current location
  const getBreadcrumbItems = () => {
    const items = [
      {
        "@type": "ListItem",
        "position": 1,
        "name": language === 'es' ? "Inicio" : "Home",
        "item": "https://logicloud.mx/"
      }
    ]

    // Add section breadcrumbs based on hash
    if (location.hash) {
      const section = location.hash.replace('#', '')
      const sectionNames: { [key: string]: { en: string; es: string } } = {
        'about': { en: 'About', es: 'Nosotros' },
        'features': { en: 'Features', es: 'Características' },
        'services': { en: 'Services', es: 'Servicios' },
        'contact': { en: 'Contact', es: 'Contacto' }
      }

      if (sectionNames[section]) {
        items.push({
          "@type": "ListItem",
          "position": 2,
          "name": sectionNames[section][language === 'es' ? 'es' : 'en'],
          "item": `https://logicloud.mx/#${section}`
        })
      }
    }

    return items
  }

  const breadcrumbItems = getBreadcrumbItems()

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbItems
  }

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>
      <nav aria-label="Breadcrumb" className="hidden">
        <ol className="flex items-center space-x-2 text-sm text-gray-600">
          {breadcrumbItems.map((item: any, index: number) => (
            <li key={item.position} className="flex items-center">
              {index > 0 && <span className="mx-2">/</span>}
              <a 
                href={item.item} 
                className={index === breadcrumbItems.length - 1 ? "text-gray-900 font-medium" : "hover:text-blue-600"}
                aria-current={index === breadcrumbItems.length - 1 ? "page" : undefined}
              >
                {item.name}
              </a>
            </li>
          ))}
        </ol>
      </nav>
    </>
  )
}

export default Breadcrumb

